import { render, staticRenderFns } from "./AsideBody.vue?vue&type=template&id=cf07f92e&scoped=true"
import script from "./AsideBody.vue?vue&type=script&lang=js"
export * from "./AsideBody.vue?vue&type=script&lang=js"
import style0 from "./AsideBody.vue?vue&type=style&index=0&id=cf07f92e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf07f92e",
  null
  
)

export default component.exports